<form [formGroup]="form" class="d-inline-flex">
  <div>
    <mat-button-toggle-group [formControlName]="nameForControl" [hideSingleSelectionIndicator]="true">
      @for (item of list; track item) {
        <mat-button-toggle [value]="item.value" (change)="onChange($event)">
          @if (dataEnum && autoTranslate || autoTranslate) {
            <mwp-text-translate [text]="item.text" [jsonKey]="item.text" />
          } @else {
            {{item.text}}
          }
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>
  <div class="ms-2 pt-1">
    @if (label) {
      <span>
        <mwp-text-translate [text]="label" [jsonKey]="label" />
      </span>
    }
  </div>
</form>